import React, { ComponentProps } from "react";
import { ButtonLink } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";
import RecommendedItemData from "../../contracts/RecommendedItem";
import Skeleton from "../../../Skeleton";
const RecommendedItemSkeleton = () => <div className="flex flex-col items-center" data-sentry-component="RecommendedItemSkeleton" data-sentry-source-file="RecommendedItem.tsx">
    <div className="border border-solid border-[#f1f1f1] rounded-md shadow-[0_1px_2px_rgba(0,0,0,0.05)] mb-[13px] p-2">
      <Skeleton className={cls("w-[105px] h-[105px]", "xxl:w-[109px] xxl:h-[109px]", "xxxsl:w-[134px] xxxsl:h-[134px]")} data-sentry-element="Skeleton" data-sentry-source-file="RecommendedItem.tsx" />
    </div>
    <Skeleton className="w-[125px] h-3" data-sentry-element="Skeleton" data-sentry-source-file="RecommendedItem.tsx" />
    <Skeleton className="w-[125px] h-3 mt-1" data-sentry-element="Skeleton" data-sentry-source-file="RecommendedItem.tsx" />
    <Skeleton className="w-[125px] h-4 mt-1-1/2" data-sentry-element="Skeleton" data-sentry-source-file="RecommendedItem.tsx" />
  </div>;
interface RecommendedItemProps extends RecommendedItemData {
  loading?: boolean;
}
const RecommendedItem = ({
  loading = true,
  className,
  ...rest
}: RecommendedItemProps & ComponentProps<"div">) => loading && <RecommendedItemSkeleton /> || <ButtonLink href="##" /* TODO: replace with item link */>
      <div className={cls("flex flex-col items-center", className)} {...rest}>
        <div className={cls("max-w-[105px] max-h-[105px]", "xxl:max-w-[109px] xxl:max-h-[109px]", "xxxsl:max-w-[134px] xxxsl:max-h-[134px]")}>
          replace with image
        </div>
        <div className="max-w-[125px] max-h-[28px] text-wrap text-ellipsis">
          replace with item name/description
        </div>
        <div>replace with item price</div>
      </div>
    </ButtonLink>;
export default RecommendedItem;